import { Box, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import SkeletonWrapper from "../../../common/components/functional/skeletonWrapper/SkeletonWrapper";
import { OrderFields } from "../orderTypes";

type Props = {
  values: OrderFields;
};

const EEZY_COMPANY_NAME = "Eezy Yhtiö Oy";

const PreviewSalary = ({ values }: Props) => {
  const { t } = useTranslation(["common", "order"]);

  const localized = useAppSelector((state) => state.localized);

  const unitLabel = t("common:hourlySalaryUnit");
  const grossLabel = `(${t("common:gross")})`;

  const tesId = values.orderTemplate.tes?.id;
  const tesName = tesId ? localized.tes[tesId] : null;

  return (
    <>
      <Box
        sx={{
          marginTop: "2px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          marginBottom: "12px",
        }}
      >
        <Skeleton
          sx={{ bgcolor: "rgba(0, 0, 0, 0.04)" }}
          width="55px"
          height="48px"
          animation={false}
        />
        <Typography
          sx={{ fontSize: "20px", fontWeight: 600, marginRight: "2px" }}
          variant="header"
          color="primary"
        >
          {unitLabel}
        </Typography>
        <Typography sx={{ textTransform: "lowercase" }}>
          {grossLabel}
        </Typography>
      </Box>
      <Typography>{t("order:previouslyAcceptedConditions")}</Typography>
      <Box sx={{ marginTop: "12px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
          <Typography
            sx={{ fontWeight: 700, fontSize: "12px", whiteSpace: "nowrap" }}
          >
            {`${t("common:employer")}:`}
          </Typography>
          {/* TODO: is this always eezy yhtiöt oy? */}
          <Typography sx={{ fontSize: "12px" }}>{EEZY_COMPANY_NAME}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
          {tesName && (
            <Typography
              sx={{ fontWeight: 700, fontSize: "12px", whiteSpace: "nowrap" }}
            >
              {`${t("common:collectiveAgreement")}:`}
            </Typography>
          )}
          <SkeletonWrapper value={tesName} height="12px" width="95%">
            <Typography sx={{ fontSize: "12px" }}>{tesName}</Typography>
          </SkeletonWrapper>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
          {values.reasonForTemporaryEmployment && (
            <Typography
              sx={{ fontWeight: 700, fontSize: "12px", whiteSpace: "nowrap" }}
            >
              {`${t("order:reasonForTemporaryEmployment")}:`}
            </Typography>
          )}
          {/* TODO: needs to be refactored to id and name pair */}
          <SkeletonWrapper
            value={values.reasonForTemporaryEmployment}
            height="12px"
            width="90%"
          >
            <Typography sx={{ fontSize: "12px" }}>
              {t(`order:${values.reasonForTemporaryEmployment}`)}
            </Typography>
          </SkeletonWrapper>
        </Box>
      </Box>
    </>
  );
};

export default PreviewSalary;
